// 未解決の API リクエストのキャンセル元。http.js のインターセプタが登録する。
// store / router から http.js を import すると循環するため、import を持たないモジュールに置く。
const requestCancelSources = [];

export const registerCancelSource = (source) => {
  requestCancelSources.push(source);
};

// 未解決のリクエストをすべてキャンセルする。
// ルート遷移時に加え、ユーザーが切り替わる前（ログアウト・代理ログイン開始/終了）にも呼び、
// 切り替え前のユーザーで取得した応答が切り替え後の store に書き込まれるのを防ぐ。
export const cancelPendingRequests = () => {
  requestCancelSources.splice(0).forEach((source) => {
    source.cancel('Request canceled');
  });
};
